import { render } from "./ClinicalCaseShow.vue?vue&type=template&id=01074f02&scoped=true"
import script from "./ClinicalCaseShow.vue?vue&type=script&lang=js"
export * from "./ClinicalCaseShow.vue?vue&type=script&lang=js"

import "./ClinicalCaseShow.vue?vue&type=style&index=0&id=01074f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01074f02"]])

export default __exports__